import { useState } from 'react';
import { useRouter } from 'next/router';

import { useOnceReveal } from '@common/hooks';
import { gotoLogin } from '@common/utils';

import { SizeRecommendExample } from '../assets/images/sizeRecommendExampleImage';
import { useLegacySizeRecommendationService } from './useLegacySizeRecommendationService';

export const useLegacyUnregisteredSizeService = () => {
  const [isBodyInfoShown, setIsBodyInfoShown] = useState(false);
  const { refetch, sizeRecommendation, catalogProductId } = useLegacySizeRecommendationService();
  const { userAccount } = sizeRecommendation;
  const router = useRouter();
  const { targetRef, isRevealed } = useOnceReveal({ threshold: 0.2 });
  const sizeRecommendExampleImage = isRevealed ? getExampleImageByLanguage('ko') : '';

  const handleBodyInfoClick = () => {
    if (!userAccount.name) {
      const url = `${window.location.origin}/catalog/products/${catalogProductId}`;
      sessionStorage.setItem(`size_recommend_login?${catalogProductId}`, 'true');
      gotoLogin({ redirect_url: url });
      return;
    }

    sessionStorage.setItem(`size_recommend_body_info?${catalogProductId}`, 'true');
    setIsBodyInfoShown(true);

    router.push('/profile/body');
  };

  return {
    isBodyInfoShown,
    refetch,
    setIsBodyInfoShown,
    handleBodyInfoClick,
    targetRef,
    sizeRecommendExampleImage,
  };
};

function getExampleImageByLanguage(language: 'ko' | 'en' | 'ja') {
  const image = SizeRecommendExample[language] ?? SizeRecommendExample.ko;
  return image;
}
